import request from '../request'

export default {
  getDemarcaciones: function () {
    return request.get('demarcacion')
  }
}
